import { render, staticRenderFns } from "./IndicativoReservasComponent.vue?vue&type=template&id=3fb527d2&scoped=true&"
import script from "./IndicativoReservasComponent.vue?vue&type=script&lang=js&"
export * from "./IndicativoReservasComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndicativoReservasComponent.vue?vue&type=style&index=0&id=3fb527d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb527d2",
  null
  
)

export default component.exports